// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ilsvwb0 {
  max-width: 100%;
}
.ilsvwb1 {
  padding: 0 16px;
}
.ilsvwb5 {
  width: 100%;
}
@media screen and (max-width: 768px) {
  .ilsvwb3 {
    padding-left: 10px;
    padding-right: 10px;
  }
  .ilsvwb4 {
    padding-left: 10px;
    padding-right: 10px;
  }
}
@media screen and (min-width: 768px) {
  .ilsvwb0 {
    max-width: 580px;
  }
  .ilsvwb1 {
    padding: 44px 32px 25px;
  }
  .ilsvwb2 {
    max-width: 288px;
  }
  .ilsvwb3 {
    max-width: 330px;
    padding-left: 20px;
    padding-right: 20px;
  }
  .ilsvwb4 {
    max-width: 330px;
    padding-left: 20px;
    padding-right: 20px;
  }
  .ilsvwb5 {
    max-width: 137px;
  }
}`, "",{"version":3,"sources":["webpack://./../../node_modules/@vanilla-extract/webpack-plugin/extracted.js"],"names":[],"mappings":"AAAA;EACE,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;EACE,WAAW;AACb;AACA;EACE;IACE,kBAAkB;IAClB,mBAAmB;EACrB;EACA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;AACF;AACA;EACE;IACE,gBAAgB;EAClB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;EACrB;EACA;IACE,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;EACrB;EACA;IACE,gBAAgB;EAClB;AACF","sourcesContent":[".ilsvwb0 {\n  max-width: 100%;\n}\n.ilsvwb1 {\n  padding: 0 16px;\n}\n.ilsvwb5 {\n  width: 100%;\n}\n@media screen and (max-width: 768px) {\n  .ilsvwb3 {\n    padding-left: 10px;\n    padding-right: 10px;\n  }\n  .ilsvwb4 {\n    padding-left: 10px;\n    padding-right: 10px;\n  }\n}\n@media screen and (min-width: 768px) {\n  .ilsvwb0 {\n    max-width: 580px;\n  }\n  .ilsvwb1 {\n    padding: 44px 32px 25px;\n  }\n  .ilsvwb2 {\n    max-width: 288px;\n  }\n  .ilsvwb3 {\n    max-width: 330px;\n    padding-left: 20px;\n    padding-right: 20px;\n  }\n  .ilsvwb4 {\n    max-width: 330px;\n    padding-left: 20px;\n    padding-right: 20px;\n  }\n  .ilsvwb5 {\n    max-width: 137px;\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
